import { createStyles, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';
import FsBody from './FsBody';

const FsBodyMediumBold = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 500,
    },
  })
)((props: TypographyAllProps) => <FsBody {...props} />);

export default FsBodyMediumBold;
